/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageMainTabViewComponent from "./PageMainTabView.js";
import { useParams, useLocation } from "react-router-dom"
import {
  CommoditySpeaker,
  CommodityPlan,
  CommodityService,
  MemberInfoModify,
  OnlineService,
  OrderDetail,
  Caption01,
  Caption02,
  Caption0201,
  Caption03,
  Caption0301,
  Caption0302,
  Caption0303,
  Caption0304,
  Caption04,
  Caption05,
  Smart,
  Teaching01,
  Teaching02,
  Teaching0201,
  Teaching0202,
  Teaching0203,
  Teaching0204,
  Teaching0205,
  Recommend,
  SoundOn,
  HamiMall,
  Mod,
  Mod2,
  Activity,
  WakeUp11110,
  WakeUp11111,
  WakeUp11112,
  Lullabobby11205
} from '../MainPage/index'

const PageSelector = (props) => {
  let component = null;
  if (props.selectedPage === "CommoditySpeaker") {
    component = <CommoditySpeaker />
  } else if (props.selectedPage === "CommodityPlan") {
    component = <CommodityPlan />
  } else if (props.selectedPage === "CommodityService") {
    component = <CommodityService />
  } else if (props.selectedPage === "MemberInfoModify") {
    component = <MemberInfoModify />
  } else if (props.selectedPage === "OnlineService") {
    component = <OnlineService />
  } else if (props.selectedPage === "OrderDetail") {
    component = <OrderDetail />
  } else if (props.selectedPage === "Caption01") {
    component = <Caption01 />
  } else if (props.selectedPage === "Caption02") {
    component = <Caption02 />
  } else if (props.selectedPage === "Caption0201") {
    component = <Caption0201 />
  } else if (props.selectedPage === "Caption03") {
    component = <Caption03 />
  } else if (props.selectedPage === "Caption0301") {
    component = <Caption0301 />
  } else if (props.selectedPage === "Caption0302") {
    component = <Caption0302 />
  } else if (props.selectedPage === "Caption0303") {
    component = <Caption0303 />
  } else if (props.selectedPage === "Caption0304") {
    component = <Caption0304 />
  } else if (props.selectedPage === "Caption04") {
    component = <Caption04 />
  } else if (props.selectedPage === "Caption05") {
    component = <Caption05 />
  } else if (props.selectedPage === "Smart") {
    component = <Smart />
  } else if (props.selectedPage === "Teaching01") {
    component = <Teaching01 />
  } else if (props.selectedPage === "Teaching02") {
    component = <Teaching02 />
  } else if (props.selectedPage === "Teaching0201") {
    component = <Teaching0201 />
  } else if (props.selectedPage === "Teaching0202") {
    component = <Teaching0202 />
  } else if (props.selectedPage === "Teaching0203") {
    component = <Teaching0203 />
  } else if (props.selectedPage === "Teaching0204") {
    component = <Teaching0204 />
  } else if (props.selectedPage === "Teaching0205") {
    component = <Teaching0205 />
  } else if (props.selectedPage === "Recommend") {
    component = <Recommend />
  } else if (props.selectedPage === "Activity") {
    component = <Activity />
  } else if (props.selectedPage === "SoundOn") {
    component = <SoundOn />
  } else if (props.selectedPage === "HamiMall") {
    component = <HamiMall />
  } else if (props.selectedPage === "Mod") {
    component = <Mod />
  } else if (props.selectedPage === "Mod2") {
    component = <Mod2 />
  } else if (props.selectedPage === "WakeUp11110") {
    component = <WakeUp11110 />
  } else if (props.selectedPage === "WakeUp11111") {
    component = <WakeUp11111 />
  } else if (props.selectedPage === "WakeUp11112") {
    component = <WakeUp11112 />
  } else if (props.selectedPage === "Lullabobby11205") {
    component = <Lullabobby11205 />
  } else {
    if (props.rootPage !== undefined && props.rootPage !== "")
      return <PageSelector selectedPage={props.rootPage} />
  }
  return component;
}
const PageContainer = () => {
  const { root, pager } = useParams();
  const [listItem, setListItem] = useState([]);
  const [selectedPage, setPage] = useState("");
  const [rootPage, setRootPage] = useState("");

  let location = useLocation();

  useEffect(() => {
    let isComponentMounted = true;
    // fetch("/apt/sheet/"+root)
    const fetchData = async () => {
      const apiUrl = process.env.REACT_APP_SHEET_API + root;
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (isComponentMounted) {
        setRootPage(result[0].id);
      }
      // setShow(show);
      if (pager !== "" && pager !== undefined && pager != null) {
        if (isComponentMounted) {
          setPage(pager);
        }
      } else {
        if (isComponentMounted) {
          setPage(result[0].id);
        }
      }

      if (isComponentMounted) {
        setListItem(result);
      }
    }

    fetchData();
    return () => {
      isComponentMounted = false;
    }
  }, [location])

  return (
    <div className="content">
      <PageMainTabViewComponent selectedPage={selectedPage} setPage={setPage} list={listItem}></PageMainTabViewComponent>
      <PageSelector selectedPage={selectedPage} rootPage={rootPage} />
    </div>
  )
}

export default PageContainer;